<template>
  <div class="main_wrapper">
    <div class="inner_top_header">
      <div class="tab_items">
        <p class="active" @click="$emit('changeTab', 1)">Movies</p>
        <p @click="$emit('changeTab', 2)">Series</p>
      </div>
      <div class="search">
        <input type="text" v-model="search" placeholder="Search">
        <span>
          <b-icon icon="magnify" type="red"></b-icon>
        </span>
      </div>
    </div>
    <div class="wrapper_body" v-if="allData.length > 0 && !loading" :class="{activeSide: $store.state.sidebar}">
      <dataCard @edit="edit(data)" v-for="(data, index) in dataComp" @deleteMedia="deleteMovie(data.id)" :key="index" :dataObj = 'data' />
    </div>
    <div v-if="allData.length == 0 || loading == true">
      <widgetNotfound v-if="loading" title="Please Wait..." subtitle="Loading Data..."></widgetNotfound>
      <widgetNotfound v-else title="No Data Found" subtitle="No records available at the moment. Add New"></widgetNotfound>
    </div>

    <AddNewMovie v-if="showModal || selected_data" @refresh="getAllMedia()" @closeModal="$emit('closeModal'); selected_data = null" :dataObj="selected_data"/>
    
  </div>
</template>

<script>
import dataCard from '../components/dataCard.vue';
import AddNewMovie from '../modals/addNewMovie.vue';

export default {
  props: {
    showModal: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      search: '',
      loading: true,
      allowModal: true,
      selected_data: null,
      allData: []
    }
  },
  components: {dataCard, AddNewMovie},
  methods: {
    switchTab(type) {
      let vm = this;
      vm.$emit("tab", type);
    },
    getAllMedia() {
      let vm = this;
      vm.loading = true
      vm.$store.dispatch('GET_AUD_VID_BY_TYPE', {type: 'movies'})
      .then((res) => {
        vm.loading = false
        vm.allData = res.data
      })
      .catch((err) => {
        vm.loading = false
        vm.allData = []
      })
    },
    edit(data) {
      let vm = this;
      vm.selected_data = data;
    },
    deleteMovie(id) {
      let vm = this;
      vm.$buefy.dialog.confirm({
        title: 'Deleting Movie',
        message: 'Are you sure you want to delete this Movie?',
        confirmText: 'Delete',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          vm.$store.dispatch('DELETE_AUD_VID', {id: id})
            .then(res => {
              vm.$notify({
                group: "status",
                type: "success",
                title: "SUCCESS!!!",
                text: 'Movie Deleted Successfully',
              });
              vm.loading = true;
              vm.getAllMedia();
            })
            .catch(err => {
              vm.$notify({
                group: "status",
                type: "error",
                title: "OOPS!!!",
                text: 'Something went wrong',
              });
              console.log(err);
            })
        }
      })
    }
  },
  mounted() {
    let vm = this;
    vm.getAllMedia();
  },
  computed: {
    dataComp() {
      let vm = this;
      return vm.allData.filter(data => data.title.toLowerCase().includes(vm.search.toLowerCase()))
    }
  }
}
</script>

<style lang="scss" scoped>
  .main_wrapper {
    overflow: hidden;
    overflow-y: auto;
    .inner_top_header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px;
      position: sticky;
      top: 0;
      background: var(--white, #FFF);
      z-index: 10;
      width: 100%;
      border-bottom: 1px solid #ddd;
      column-gap: 30px;
      overflow-x: auto;
      .tab_items {
        display: flex;
        column-gap: 20px;
        p {
          cursor: pointer;
          font-size: 18px;
          font-weight: 600;
          position: relative;
          &::before {
            position: absolute;
            width: 0%;
            transition: .5s;
            left: 0;
            bottom: -5px;
            content: '';
            height: 2px;
            border-radius: 5px;
            background: var(--wecodefy-secondary-color, #9fc953);
          }
          &.active {
            color: var(--wecodefy-secondary-color, #9fc953);
            &::before {
              width: 80%;
            }
          }
        }
      }
      .search {
        display: flex;
        align-items: center;
        position: relative;
        input {
          padding: 5px 10px;
          width: 300px;
          border-radius: 5px;
          border: none;
          background: #dbdbdb;
          background: #eeeeee;
          border: 1px solid #dbdbdb;
          outline: none;
          @media (max-width: 500px) {
            width: 250px;
          }
          @media (max-width: 433px) {
            width: 200px;
          }
        }
        span {
          position: absolute;
          right: 5px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
    .wrapper_body {
      height: calc(100% - 60px);
      display: grid;
      padding: 20px;
      grid-template-columns: repeat(6, calc(100%/6.4));
      row-gap: 50px;
      overflow-y: auto;
      justify-content: space-between;
      @media (max-width: 1307px) {
        grid-template-columns: repeat(5, calc(100%/5.3));
      }
      @media (max-width: 1000px) {
        grid-template-columns: repeat(4, calc(100%/4.25));
      }
      @media (max-width: 768px) {
        grid-template-columns: repeat(3, calc(100%/3.15));
        row-gap: 30px;
      }
      @media (max-width: 600px) {
        grid-template-columns: repeat(2, calc(100%/2.05));
      }
      @media (max-width: 450px) {
        grid-template-columns: repeat(1, 1fr);
      }
      &.activeSide {
        grid-template-columns: repeat(5, calc(100%/5.3));
        @media (max-width: 1300px) {
        grid-template-columns: repeat(4, calc(100%/4.25));
        }
        @media (max-width: 1100px) {
        grid-template-columns: repeat(3, calc(100%/3.15));
        }
        @media (max-width: 966px) {
        grid-template-columns: repeat(4, calc(100%/4.25));
        }
        @media (max-width: 768px) {
        grid-template-columns: repeat(3, calc(100%/3.15));
          row-gap: 30px;
        }
        @media (max-width: 600px) {
        grid-template-columns: repeat(2, calc(100%/2.05));
        }
        @media (max-width: 450px) {
          grid-template-columns: repeat(1, 1fr);
        }
      }
    }
    .noFound {
      text-align: center;
      margin: 20px auto;
    }
  }
</style>